import { createElement } from 'react';
import {
  MailFilled,
  MessageFilled,
  PhoneFilled,
  VideoCameraFilled,
  UserOutlined,
} from '@ant-design/icons';

import type { ReactElement } from 'react';

type MethodTagVariant = 'phone' | 'sms' | 'email' | 'video' | 'inPerson';

const METHOD_VARIANT_SUFFIX: Record<MethodTagVariant, string> = {
  phone: 'phone',
  sms: 'sms',
  email: 'email',
  video: 'video',
  inPerson: 'in-person',
};

const isSupportedMethodVariant = (
  variant: string,
): variant is MethodTagVariant =>
  Object.prototype.hasOwnProperty.call(METHOD_VARIANT_SUFFIX, variant);

export const getMethodTagClassName = (
  styles: Record<string, string>,
  variant?: string,
): string | undefined => {
  if (!variant || !isSupportedMethodVariant(variant)) {
    return undefined;
  }

  const suffix = METHOD_VARIANT_SUFFIX[variant];
  return styles[`method-tag-${suffix}`];
};

export const renderMethodIcon = (
  variant?: MethodTagVariant,
  className?: string,
): ReactElement | null => {
  switch (variant) {
    case 'phone':
      return createElement(PhoneFilled, { className, 'aria-hidden': true });
    case 'sms':
      return createElement(MessageFilled, { className, 'aria-hidden': true });
    case 'email':
      return createElement(MailFilled, { className, 'aria-hidden': true });
    case 'video':
      return createElement(VideoCameraFilled, {
        className,
        'aria-hidden': true,
      });
    case 'inPerson':
      return createElement(UserOutlined, { className, 'aria-hidden': true });
    default:
      return null;
  }
};
